import React, { useState, useEffect,useCallback } from "react";
import {  Container, Col, Row, Button, Form} from "react-bootstrap";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { apiUrl } from "../commons/inFormTypes";
import { useDropzone } from "react-dropzone";
import 'react-toastify/dist/ReactToastify.css';
import LoaderBtn from "../components/LoaderBtn";
import { useNavigate } from 'react-router-dom'
import AllHeader from "../components/AllHeader";

const Test2 = () => {
    const [url, setUrl] = useState("");
    const [header, setHeader] = useState("");
    const [body, setBody] = useState("")
    const axios = require("axios");  

    const handleSubmit = (e) => {

        // axios
        //   .post(url ,   JSON.stringify(body),)
        axios({
            method: "get",
            url: url,
             headers:JSON.parse(header),            
          })
          .then((res) => {
                console.log(res)
          });
      };


  return (
    <div>
          <div className="pt-5">

      <Container>
        <Row className="justify-content-center">
          <Col xs={11} lg={7} className="rgc-title">
          
            <Form>
              <Row className="justify-content-center">
                <Col lg="10" className="mb-3">
                  <Form.Group>
                    <Form.Label> url</Form.Label>
                    <Form.Control
                      className="rgc-font-number"
                      placeholder="url"
                      id="txtname"
                      type="text"
                      value={url}
                      onChange={(e) => setUrl(e.target.value)}
                    ></Form.Control>
                  </Form.Group>
                </Col>

          
                <Col lg="10" className="mb-3">
                  <Form.Group>
                    <Form.Label>header</Form.Label>
                    <Form.Control
                      className="rgc-font-number"
                      placeholder="header"
                      id="txtname"
                      type="text"
                      value={header}
                      onChange={(e) => setHeader(e.target.value)}
                    ></Form.Control>
                  </Form.Group>
                </Col>

                <Col lg="10" className="mb-3">
                  <Form.Group>
                    <Form.Label> body</Form.Label>
                    <Form.Control
                      className="rgc-font-number"
                      placeholder="body "
                      id="txtname"
                      type="text"
                      value={body}
  
                      onChange={(e) => setBody(e.target.value)}
                    ></Form.Control>
                  </Form.Group>
                </Col>
            
                        
                <Col xs="9" md="5"  className="text-center">
                  <Button
                    className="btn-fill rgc-btn"
                    type="button"
                    variant="primary"
                    onClick={handleSubmit}
                  >
                    <span>ثبت</span>
                  </Button>
                </Col>

              </Row>
            </Form>
          </Col>
        </Row>
      </Container>

      {/* <Loaders loads={load} /> */}
    </div>
    </div>
  )
}

export default Test2
